import { CSmartTable } from '@coreui/react-pro'
import Add from '@mui/icons-material/Add'
import Delete from '@mui/icons-material/Delete'
import Edit from '@mui/icons-material/Edit'
import Upload from '@mui/icons-material/Upload'
import { CircularProgress, Dialog, DialogActions, DialogTitle, IconButton } from '@mui/material'
import debounce from 'lodash/debounce'
import { useCallback, useContext, useEffect, useState } from 'react'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import ClinicHeader from 'src/clinic/components/ClinicHeader'
import DrugEditComponent from 'src/clinic/components/DrugEdit/DrugEditComponent'
import { DRUG_INFO_OBJECT } from 'src/clinic/components/DrugEdit/drug-utils'
import { getCPData, getCPDataWithParams, postCPDataWithParams } from 'src/clinic/services'
import { CustomInput } from 'src/consumer/components/helperComponents'
import { ROLE_TYPES, frequencyOptions, timingOptions } from 'src/consumer/constants'
import { checkAndGetTargetValue } from 'src/consumer/helpers/utilFunctions'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import { SavingCircularProgress } from 'src/mentor/components/MentorProfilePage/MentorProfilePageStyles'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { StyledAddStaffButton } from '../onboardng/ClinicOnboardingStyles'
import './pharmacyPageStyles.css'
import {
  PharmacyDatabaseForm,
  PharmacySaveButton,
  PharmacySearchContainer,
  PharmacyTableContainer,
  PharmcyPageContainer,
} from './styledComponents'
import { GenericHeaderBackButton } from 'src/consumer/components/UserActivityPage/MyPlanComponents'

export default function PharmacyDatabase() {
  const { clinicId } = useParams()
  const { chosenRoleFlow, ownerData, assistantData } = useContext(ClinicDataContext)

  let thisClinicData
  if (chosenRoleFlow === ROLE_TYPES.roleClinicOwner) {
    thisClinicData = ownerData?.associatedClinicsData?.find((item) => item?.id === clinicId)
  } else if (chosenRoleFlow === ROLE_TYPES.roleClinicAssistant) {
    thisClinicData = assistantData?.associatedClinicsData?.find((item) => item?.id === clinicId)
  }

  const [pharmacyMedList, setPharmacyMedList] = useState()
  const [selectedMedicine, setSelectedMedicine] = useState(DRUG_INFO_OBJECT)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const [loadingMeds, setLoadingMeds] = useState(false)
  const [hasMoreMeds, setHasMoreMeds] = useState(true)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [saving, setSaving] = useState(false)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const [drugToDelete, setDrugToDelete] = useState()

  console.log(thisClinicData)

  async function getPharmacyMedList(pageToUse = 1, searchToUse) {
    const resp = await getCPDataWithParams(`/api/secure/drug/list`, {
      clinicId: thisClinicData?.id,
      clinicBrandId: thisClinicData?.clinicBrandId,
      page: pageToUse,
      pageSize: 10,
      search: searchToUse,
    })
    if (resp.status === 200) {
      if (resp.data && resp.data.length > 0) {
        setPharmacyMedList(resp.data.map((data) => ({ ...DRUG_INFO_OBJECT, ...data })))
        setPage(pageToUse)
      } else {
        setHasMoreMeds(resp.data.length < 0 ? false : true)
      }
    }
  }

  async function getMorePharmacyMedList(nextPage, searchToUse = search) {
    const resp = await getCPDataWithParams(`/api/secure/drug/list`, {
      clinicId: thisClinicData?.id,
      clinicBrandId: thisClinicData?.clinicBrandId,
      page: nextPage,
      pageSize: 10,
      search: searchToUse,
    })
    if (resp.status === 200) {
      setPage(nextPage)
      if (resp.data && resp.data.length > 0) {
        setPharmacyMedList((prev) => [
          ...(prev || []),
          ...(resp.data.map((data) => ({ ...DRUG_INFO_OBJECT, ...data })) || []),
        ])
      } else {
        setHasMoreMeds(false)
      }
    }
  }

  async function getNextPage() {
    getMorePharmacyMedList(page + 1)
    setLoadingMeds(false)
  }

  async function saveDrug(drugToSave) {
    const resp = await postCPDataWithParams(
      '/api/secure/drug/save',
      {
        ...drugToSave,
        dosage: drugToSave?.dosage
          ?.split('-')
          ?.map((dosg) => (dosg === '' ? '0' : dosg))
          ?.join('-'),
        clinicIds: [
          ...(drugToSave?.clinicIds || [])?.filter((clinicId) => clinicId !== thisClinicData?.id),
          thisClinicData?.id,
        ],
        clinicBrandIds: [
          ...(drugToSave?.clinicBrandIds || [])?.filter(
            (clinicBrandId) => clinicBrandId !== thisClinicData?.clinicBrandId,
          ),
          thisClinicData?.clinicBrandId,
        ],
      },
      { clinicId: thisClinicData?.id },
    )
    if (resp.status === 200) {
      toast.success(`Saved ${drugToSave.title}.`)
      setLoading(true)
      setHasMoreMeds(true)
      await getPharmacyMedList(1)
      setLoading(false)
    } else {
      toast.error('Something went wrong.')
    }
  }

  async function disableDrug(item) {
    const resp = await getCPData(`/api/drug/disable?id=${item.id}`)
    if (resp.status === 200) {
      toast.success('Deleted successfully')
    } else {
      toast.error("Couldn't delete the medicine")
    }
  }

  function handleChangeObject(event) {
    if (event.target.id)
      setSelectedMedicine((prev) => ({
        ...prev,
        [event.target.id]: checkAndGetTargetValue(event),
      }))
    else {
      setSelectedMedicine(checkAndGetTargetValue(event))
    }
  }

  async function Setup() {
    setLoading(true)
    var promises = []
    promises = [...promises, getPharmacyMedList()]
    await Promise.all(promises)
    setLoading(false)
  }

  function handleEdit(item) {
    setSelectedMedicine(item)
    window.scrollTo(0, 0)
  }

  async function deleteDrug() {
    setLoading(true)
    await disableDrug(drugToDelete)
    handleCloseDeleteConfirmationDialog()
    setLoading(false)
  }
  function handleDelete(item) {
    setDrugToDelete(item)
    setShowDeleteDialog(true)
  }

  const [sentryRef] = useInfiniteScroll({
    loading: loadingMeds,
    hasNextPage: hasMoreMeds,
    onLoadMore: getNextPage,
    rootMargin: '0px 0px 400px 0px',
  })

  async function searchFunction(e) {
    setLoading(true)
    setSearch(e.target.value)
  }

  function clearMed() {
    setSelectedMedicine(DRUG_INFO_OBJECT)
  }

  function handleCloseDeleteConfirmationDialog() {
    setShowDeleteDialog(false)
  }

  async function handleSubmit(event) {
    setSaving(true)
    const form = event.currentTarget
    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      event.preventDefault()
      await saveDrug(selectedMedicine)
      clearMed()
    }
    setSaving(false)
  }

  const debouncedSearch = useCallback(
    debounce(async (value) => {
      await getPharmacyMedList(1, value)
      setLoading(false)
    }, 500),
    [],
  )

  useEffect(() => {
    debouncedSearch(search)
  }, [search])

  useEffect(() => {
    // later doctor and pharmacist
    if (
      chosenRoleFlow === ROLE_TYPES.roleClinicOwner ||
      chosenRoleFlow === ROLE_TYPES.roleClinicAssistant
    ) {
      Setup()
    } else {
      navigate('/aumhum-for-clinics')
    }
  }, [])

  return (
    <>
      <ClinicHeader greetingsEnabled={true} />
      <GenericHeaderBackButton
        clickfunction={() => window.history.back()}
        styles={{ margin: '20px' }}
      />
      <PharmcyPageContainer>
        <PharmacyDatabaseForm onSubmit={handleSubmit}>
          <DrugEditComponent
            medicineObject={selectedMedicine}
            setMedicineObject={setSelectedMedicine}
            handleChangeObject={handleChangeObject}
          />
          <div className="d-flex justify-content-end align-items-center gap-2 pt-2">
            {selectedMedicine?.id !== '' && (
              <StyledAddStaffButton btnColor="none" onClick={clearMed}>
                <div>Clear Form</div>
              </StyledAddStaffButton>
            )}
            <PharmacySaveButton disabled={saving} type="submit">
              {saving && (
                <SavingCircularProgress
                  size={20}
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                  }}
                />
              )}
              {selectedMedicine?.id === '' ? (
                <>
                  <div>Add Medicine</div>
                  <Add />
                </>
              ) : (
                <>
                  <div>Update Drug</div>
                  <Upload />
                </>
              )}
            </PharmacySaveButton>
          </div>
        </PharmacyDatabaseForm>
        <hr></hr>
        <PharmacyTableContainer>
          <PharmacySearchContainer>
            <CustomInput defaultValue={search} onChange={searchFunction} placeholder="Search..." />
          </PharmacySearchContainer>
          {/* <DataGrid
            rows={pharmacyMedList || []}
            columns={columns}
            loading={loading}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            disableColumnMenu={true}
            pageSizeOptions={[5]}
            rowSelection={false}
            disableRowSelectionOnClick
          /> */}
          <CSmartTable
            items={pharmacyMedList || []}
            columns={columns}
            loading={loading}
            // columnSorter
            tableProps={{
              hover: true,
              striped: true,
              responsive: true,
            }}
            pagination={false}
            itemsPerPage={10000000000000000}
            scopedColumns={scopedColumns(handleEdit, handleDelete)}
          />
          {(loadingMeds || hasMoreMeds) && !loading && (
            <div
              ref={sentryRef}
              style={{
                display: 'flex',
                flexDirection: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '20px 0px 0px 0px',
                width: '100%',
              }}
            >
              Fetching more medicines
              <CircularProgress sx={{ color: '#A864FF' }} size={30} />
            </div>
          )}
        </PharmacyTableContainer>
        <Dialog open={showDeleteDialog} onClose={handleCloseDeleteConfirmationDialog}>
          <DialogTitle>Do you want to delete this medicine?</DialogTitle>
          <DialogActions>
            <StyledAddStaffButton btnColor="none" onClick={handleCloseDeleteConfirmationDialog}>
              Close
            </StyledAddStaffButton>
            <PharmacySaveButton onClick={deleteDrug} disable={loading}>
              Delete
            </PharmacySaveButton>
          </DialogActions>
        </Dialog>
      </PharmcyPageContainer>
    </>
  )
}

const columns = [
  {
    key: 'title',
    label: 'Medicine Name',
    _style: { minWidth: '202px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'genericName',
    label: 'Generic Name',
    minWidth: 200,
    _style: { minWidth: '100px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'qty',
    label: 'Qty',
    _style: { minWidth: '45px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'dosage',
    label: 'Dosage',
    _style: { minWidth: '60px' },
    filter: false,
    sorter: false,
  },

  {
    key: 'unit',
    label: 'Unit',
    _style: { minWidth: '60px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'timing',
    label: 'Time',
    _style: { minWidth: '75px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'whatTime',
    label: 'When',
    _style: { minWidth: '110px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'appliedWhere',
    label: 'Applied Where',
    minWidth: 150,
    _style: { minWidth: '140px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'frequency',
    label: 'Frequency',
    _style: { minWidth: '100px' },
    minWidth: 100,
    filter: false,
    sorter: false,
  },
  {
    key: 'actions',
    label: '',
    maxWidth: 50,
    _style: { minWidth: '50px' },
    filter: false,
    sorter: false,
  },
]

function scopedColumns(handleEdit, handleDelete) {
  return {
    actions: (item) => (
      <td>
        <IconButton onClick={() => handleEdit(item)}>
          <Edit />
        </IconButton>
        <IconButton onClick={() => handleDelete(item)}>
          <Delete />
        </IconButton>
      </td>
    ),
    timing: (item) => (
      <td>{timingOptions.find((timing) => timing.id === item.timing)?.title || item.timing}</td>
    ),
    frequency: (item) => (
      <td>
        {frequencyOptions.find((freq) => freq.id === item.frequency)?.title || item.frequency}
      </td>
    ),
  }
}
